import React, { useState } from "react";
import axios from "axios";
import "./AdminLogin.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config/api";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const loginHandler = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${API_BASE_URL}/api/admin/login`, { email, password });
            if (res.data.success) {
                localStorage.setItem("admin_token", res.data.token);
                window.location.href = "/admin/dashboard";
            }
        } catch (err) {
            setError("Invalid Credentials");
        }
    };
    return (
        <div className="admin-login-container">
            <form className="admin-login-form" onSubmit={loginHandler}>
                <div className="logo-wrapper">
                    <img src={logo} alt="Logo" className="admin-logo" />
                </div>
                <h2 className="admin-title">Admin Sign In</h2>
                {error && <p className="error">{error}</p>}
                <label>Email</label>
                <input
                    type="text"
                    placeholder="Enter your email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <label>Password</label>
                <div className="password-wrapper">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <span
                        className="eye-icon"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                    </span>
                </div>
                <button type="submit" className="login-button">Sign In</button>
            </form>
        </div>
    );
}
